/* eslint-disable @typescript-eslint/no-unused-vars */
// ModalHourExtract.js
import styled from "styled-components";
import { Container, Row, Col } from "react-bootstrap";
import { useEffect, useState } from "react";
import { locale, addLocale } from "primereact/api";
import { useMsal } from "@azure/msal-react";
import { ReactComponent as InfoIcon } from "../../assets/icons/Information.svg";
import { ptBrDatepickerTranslations } from "../../i18n/locales/pt-br";
import ModalHourExtractStyles from "../../styles/pages/Schedule/ModalHourExtractStyles";
import Dialog from "../../components/Dialog";
import DialogStyles from "../../styles/components/DialogStyles";
import StringUtils from "../../utils/types/StringUtils";
import { axiosGetRequest } from "../../api/ApiClient";
import GenericUtils from "../../utils/GenericUtils";

addLocale("pt-BR", ptBrDatepickerTranslations);

locale("pt-BR");

// Styled Components
const StyledInfoIcon = styled(InfoIcon)`
    fill: black;
    width: 16px;
    height: 16px;
    margin-left: 8px;
    cursor: pointer;
    position: relative;
    &:hover {
        fill: #555;
    }
`;

const Tooltip = styled.div<{ $visible: boolean }>`
    visibility: ${(props) => (props.$visible ? "visible" : "hidden")};
    background-color: white;
    color: black;
    text-align: left;
    border-radius: 8px;
    border: 1px solid #ccc; /* Adiciona borda para destaque */
    padding: 12px;
    position: absolute;
    z-index: 10;
    bottom: 150%; /* Posiciona o tooltip acima */
    left: 50%;
    transform: translateX(-50%);
    width: 300px;
    box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);

}
`;

const { StyledModalTitle, StyledContainerButton, StyledModalText } =
    DialogStyles;

const { StyledCalendar, StyledModalHeader, BtnOk } = ModalHourExtractStyles;

interface IModalProps {
    open: boolean;
    onClose?: (callback?: any) => void;
    mes: any;
    ano: any;
    matricula: string;
    date: Date;
}

function ModalHourExtract(props: IModalProps) {
    const [period, setPeriod] = useState<any>(props.date);
    const [month, setMonth] = useState<any>(props.mes);
    const [year, setYear] = useState<any>(props.ano);
    const handleChangeDate = (event: any) => {
        setPeriod(new Date(event.value));
        setMonth(event.value.getMonth() + 1);
        setYear(event.value.getFullYear());
    };

    const { instance: msalAplication } = useMsal();
    const acessToken = GenericUtils.getAccessTokenDocente();
    const [totalHoursMonth, setTotalHoursMonth] = useState(0);
    const [totalHours2, setTotalHours2] = useState(0);
    const [totalHoursPendent, setTotalHoursPendent] = useState(0);
    const [totalHoursFree, setTotalHoursFree] = useState(0);

    async function getInfo() {
        const response = await axiosGetRequest(
            `/docente/v1/agendas/extrato-hora?matricula=${props.matricula}&mes=${month}&ano=${year}`,
            acessToken,
            msalAplication
        );

        setTotalHoursMonth(response.data.cargaHorariaMensalTotal);
        setTotalHours2(response.data.cargaHorariaMensalRealizada);
        setTotalHoursPendent(response.data.cargaHorariaMensalNaoRealizada);
        setTotalHoursFree(response.data.cargaHorariaMensalIsentaCheckin);
    }

    useEffect(() => {
        getInfo();
    }, [period]);

    const spaceBetween = "space-between";
    const borderModal = "solid 1px #f0f2f2";

    const [visibleTooltip, setVisibleTooltip] = useState<string | null>(null);

    const showTooltip = (tooltipId: string) => {
        setVisibleTooltip(tooltipId);
    };

    const hideTooltip = () => {
        setVisibleTooltip(null);
    };

    return (
        <Dialog
            className="workload"
            size="lg"
            openModal={props.open}
            onHide={props.onClose}
        >
            <Container fluid>
                <Row>
                    <Col>
                        <StyledModalTitle className="mb-3">
                            Extrato mensal de horas/aula
                        </StyledModalTitle>
                        <StyledModalText
                            style={{
                                marginBottom: "1.2em",
                                fontSize: "15px",
                            }}
                        >{`Última atualização: ${StringUtils.formatDateValueString(
                            new Date(),
                            "dd/MM/yyyy 'às' HH'h'mm'min'"
                        )}`}</StyledModalText>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <StyledModalHeader
                            style={{
                                fontWeight: "600",
                                paddingTop: "12px",
                                paddingLeft: "8px",
                            }}
                        >
                            <StyledCalendar
                                value={period}
                                onChange={handleChangeDate}
                                view="month"
                                dateFormat="MM 'de' yy"
                                yearNavigator
                                yearRange="2010:2030"
                            />
                        </StyledModalHeader>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <div
                            style={{
                                display: "flex",
                                justifyContent: spaceBetween,
                            }}
                        >
                            <div
                                style={{
                                    width: "70%",
                                    border: borderModal,
                                    textAlign: "start",
                                    padding: "12px 0 0 8px",
                                    fontSize: "15px",
                                }}
                            >
                                <p
                                    onMouseEnter={() => showTooltip("tooltip1")}
                                    onMouseLeave={hideTooltip}
                                    style={{
                                        position: "relative",
                                        fontWeight: "400",
                                        fontSize: "15px",
                                    }}
                                >
                                    Total de horas do mês
                                    <StyledInfoIcon />
                                    <Tooltip
                                        style={{ width: "320px" }}
                                        $visible={visibleTooltip === "tooltip1"}
                                    >
                                        <span
                                            style={{
                                                display: "block",
                                                textAlign: "center",
                                                fontWeight: "600",
                                                fontSize: "15px",
                                            }}
                                        >
                                            São considerados na contagem todos
                                            os tipos
                                            <br />
                                            de cartão (antecipação, hora letiva,
                                            hora não
                                            <br />
                                            letiva/permanência, matriz
                                            curricular,
                                            <br />
                                            reposição e substituição) que foram
                                            criados e
                                            <br />
                                            alocados durante o mês.
                                        </span>
                                    </Tooltip>
                                </p>
                                <p
                                    onMouseEnter={() => showTooltip("tooltip2")}
                                    onMouseLeave={hideTooltip}
                                    style={{
                                        position: "relative",
                                        fontWeight: "400",
                                        fontSize: "15px",
                                    }}
                                >
                                    Total de horas realizadas
                                    <StyledInfoIcon />
                                    <Tooltip
                                        $visible={visibleTooltip === "tooltip2"}
                                    >
                                        <span
                                            style={{
                                                display: "block",
                                                textAlign: "center",
                                                fontWeight: "600",
                                                fontSize: "15px",
                                            }}
                                        >
                                            São considerados na contagem todos
                                            <br />
                                            os cartões nos quais foi realizado
                                            ou
                                            <br />
                                            justificado o check-in durante o
                                            mês.
                                        </span>
                                    </Tooltip>
                                </p>
                                <p
                                    onMouseEnter={() => showTooltip("tooltip3")}
                                    onMouseLeave={hideTooltip}
                                    style={{
                                        position: "relative",
                                        fontWeight: "400",
                                        fontSize: "15px",
                                    }}
                                >
                                    Total de horas check-in não realizado
                                    <StyledInfoIcon />
                                    <Tooltip
                                        $visible={visibleTooltip === "tooltip3"}
                                    >
                                        <span
                                            style={{
                                                display: "block",
                                                textAlign: "center",
                                                fontWeight: "600",
                                                fontSize: "15px",
                                            }}
                                        >
                                            São considerados na contagem todos
                                            <br />
                                            os cartões alocados no passado, nos
                                            <br />
                                            quais o check-in não foi realizado
                                            ou
                                            <br />
                                            justificado durante o mês.
                                        </span>
                                    </Tooltip>
                                </p>
                                <p
                                    onMouseEnter={() => showTooltip("tooltip4")}
                                    onMouseLeave={hideTooltip}
                                    style={{
                                        position: "relative",
                                        fontWeight: "400",
                                        fontSize: "15px",
                                    }}
                                >
                                    Total de horas isentas de check-in
                                    <StyledInfoIcon />
                                    <Tooltip
                                        $visible={visibleTooltip === "tooltip4"}
                                    >
                                        <span
                                            style={{
                                                display: "block",
                                                textAlign: "center",
                                                fontWeight: "600",
                                                fontSize: "15px",
                                            }}
                                        >
                                            São considerados na contagem todos
                                            <br />
                                            os cartões alocados durante o mês
                                            <br />
                                            que estão com o status: &quot;Abono
                                            <br />
                                            administrativo&quot;, &quot;Abono
                                            legal&quot;,
                                            <br />
                                            &quot;Feriado nacional&quot;,
                                            &quot;Feriado
                                            <br />
                                            municipal&quot; e
                                            &quot;Recesso&quot;.
                                        </span>
                                    </Tooltip>
                                </p>
                            </div>
                            <div
                                style={{
                                    width: "30%",
                                    border: borderModal,
                                    textAlign: "end",
                                    padding: "12px 12px 0 8px",
                                }}
                            >
                                <p>{totalHoursMonth} h/a</p>
                                <p>{totalHours2} h/a</p>
                                <p>
                                    <span
                                        style={{
                                            color: "red",
                                            fontWeight: "bold",
                                        }}
                                    >
                                        {totalHoursPendent} h/a
                                    </span>
                                </p>
                                <p>{totalHoursFree} h/a</p>
                            </div>
                        </div>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <StyledContainerButton>
                            <BtnOk onClick={props.onClose}>Ok</BtnOk>
                        </StyledContainerButton>
                    </Col>
                </Row>
            </Container>
        </Dialog>
    );
}

export default ModalHourExtract;
